import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VisitorTracker, { getRouteTitlePath } from '@linsy-utils/page-trace';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/modules/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();

try {
  // 创建追踪器实例
  const tracker = new VisitorTracker({
    uploadUrl:
      process.env.NODE_ENV === 'production'
        ? '//itkw.linshimuye.com/api/nginx/trace'
        : '//xstpsit.linshimuye.com/api/nginx/trace',
    batchSize: 1,
    trackAnonymous: false,
    autoRecord: true, // 开启自动记录模式（默认值）
    debug: false, // 开启调试模式，在控制台输出追踪数据
    disable: false,
    plugins: [
      (data: any) => {
        return {
          ...data,
          originSystem: '4PL-SSO', // 系统标识符，每个系统须唯一
          path: getRouteTitlePath(data.url, router.getRoutes()), // 如果业务系统中已有处理好的路由标题映射关系，可自行处理这个字段
        };
      },
    ],
  });
  userStore.setVisitorTrackerInstance(tracker);
} catch (error) {
  console.error('tracker初始化页面追踪失败', error);
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})